import API from 'services/API/index';

export default function getMessageCounter() {
  return API.request({
    method: 'GET',
    url: `/notification/countNew`,
  });
}
